import { Endpoints, generateAxios } from '@matap/shared';
import { generateQuery } from './create-hooks';

export const useGenerateGatewayToken = generateQuery(Endpoints.gateway.user.token, (endpoint, payload) => ({
  queryKey: ['useGenerateGatewayToken', payload.query],
  queryFn: () => generateAxios(endpoint, payload).then((r) => r.data),
}));
